/* eslint-disable prettier/prettier */
/* prettier-ignore-file */
/* eslint-disable */
import React, { useState, useEffect } from 'react';
import styles from '../../styles/profile/EditProfileActions.module.css';
import Cancel from '../../assets/profile/Cancel.png';
import Undo from '../../assets/profile/Undo.png';
import Save from '../../assets/profile/Save.png';
import EditIcon from '../../assets/profile/Vector (8).png';

export interface EditProfileActionsProps {
	editLabel?: string;
	onEditClick?: () => void;
	onUndoClick?: () => void;
	onSaveClick?: () => void;
	onCancelClick?: () => void;
	primaryColor?: string;
	borderColor?: string;
	/** Optional external control of edit state */
	isEditing?: boolean;
	isSaveDisabled?: boolean;
}

const EditProfileActions: React.FC<EditProfileActionsProps> = ({
	editLabel = 'Edit Profile',
	onEditClick,

	onSaveClick,
	onCancelClick,
	primaryColor = '#147a58',
	borderColor = '#15734e',
	isSaveDisabled,
	isEditing: externalEditing, // optional prop from parent
}) => {
	const [isEditing, setIsEditing] = useState(externalEditing || false);

	// sync internal state when parent updates
	useEffect(() => {
		if (externalEditing !== undefined) {
			setIsEditing(externalEditing);
		}
	}, [externalEditing]);

	const handleEdit = () => {
		setIsEditing(true);
		onEditClick?.();
	};

	const handleCancel = () => {
		setIsEditing(false);
		onCancelClick?.();
	};

	const handleSave = () => {
		onSaveClick?.();
		// setIsEditing(false);
	};

	return (
		<div className={styles.container}>
			{!isEditing ? (
				<button
					className={styles.editButton}
					style={{ color: primaryColor, borderColor }}
					onClick={handleEdit}
				>
					<span>{editLabel}</span>
					<img src={EditIcon} alt="Edit" className={styles.icon} />
				</button>
			) : (
				<div className={styles.iconGroup}>
					<button
						className={`${styles.iconButton} ${styles.save}`}
						onClick={handleSave}
						disabled={isSaveDisabled}
					>
						<img src={Save} alt="Save" className={styles.icon} />
					</button>
					<button
						className={`${styles.iconButton} ${styles.cancel}`}
						onClick={handleCancel}
					>
						<img
							src={Cancel}
							alt="Cancel"
							className={styles.icon}
						/>
					</button>
				</div>
			)}
		</div>
	);
};

export default EditProfileActions;
